import type { Direction } from './findNearestElement';

export type RemoteAction = Direction | 'back' | 'select' | null;

interface RemoteKeyEvent {
  key: string;
  keyCode: number;
}

const directionsByKey: Record<string, Direction> = {
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  ArrowUp: 'up',
  Down: 'down',
  Left: 'left',
  Right: 'right',
  Up: 'up',
};

const directionsByCode: Record<number, Direction> = {
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
};

const backKeyCodes = [8, 27, 461, 1009, 10009];
const backKeys = ['Backspace', 'BrowserBack', 'Esc', 'Escape', 'GoBack'];

export const getRemoteAction = ({
  key,
  keyCode,
}: RemoteKeyEvent): RemoteAction => {
  const direction = directionsByKey[key] || directionsByCode[keyCode];
  if (direction) return direction;
  if (
    key === 'Enter' ||
    key === 'Accept' ||
    key === 'Select' ||
    keyCode === 13
  ) {
    return 'select';
  }
  if (backKeys.includes(key) || backKeyCodes.includes(keyCode)) return 'back';
  return null;
};
